import Swal from "sweetalert2";


export const saveDetails = (token, name, userId) => {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("name", name);
    if (userId) {
        sessionStorage.setItem("userId", userId.toString());
    }
}


export const removeDetails = () => {
    sessionStorage.removeItem("token")
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("login_from");
}
export const getToken = () => {
    let token = sessionStorage.getItem("token");
    if (token !== null) {
        return token;
    } else
        return null;
}
export const getName = () => {
    return sessionStorage.getItem("name")
}
export const logout = () => {
    if (sessionStorage.getItem("login_from") === "nuviosellers") {
        window.open("https://nuviosellers.com/adminLogin?logout");
    } else {
        window.location.assign("/login");
        Swal.fire({
            icon: 'success',
            toast: true,
            position: 'bottom-right',
            text: 'Successfully logout .',
            showConfirmButton: false,
            timer: 3500,
            timerProgressBar: true
        })
    }
    removeDetails();
}

//nuvioseller
export const saveLoginFromOutside = () => {
    sessionStorage.setItem("login_from", "nuviosellers");
}